<div class="card-footer" [ngClass]="classes" [ngStyle]="styles">
    <ng-content></ng-content>
</div>